import { Label, Radio, styledPolymorphic } from '@qred/components-library';
import React from 'react';
import { Grid } from '../Layout/Grid';

interface Props<T extends string | number = string> {
  options: { label: string; value: T }[];
  value: T;
  onChange: (value: T) => void;
}

export const RadioGroup = <T extends string | number>(props: Props<T>) => {
  const { value, options, onChange } = props;

  const onClick = (targetValue: T) => {
    if (targetValue !== value) {
      onChange(targetValue);
    }
  };

  return (
    <Radio.Group>
      <Grid>
        {options.map((option) => {
          const isSelected = value === option.value;

          return (
            <RadioWrap
              key={option.value}
              onClick={() => onClick(option.value)}
              $isSelected={isSelected}
            >
              <Radio
                checked={isSelected}
                label={<Label size="lg">{option.label}</Label>}
                value={option.value}
                size={'sm'}
              />
            </RadioWrap>
          );
        })}
      </Grid>
    </Radio.Group>
  );
};

export const RadioWrap = styledPolymorphic<'div', { $isSelected?: boolean }>()(
  (styled) =>
    styled(({ $isSelected, theme }) => ({
      display: 'flex',
      alignItems: 'center',
      cursor: 'pointer',
      padding: '13px 17px',
      gap: '12px',
      borderRadius: '4px',
      transition: 'all 0.2s ease',
      border: `1px solid ${
        $isSelected
          ? theme.fn.themeColor('Border/Active')
          : theme.fn.themeColor('Border/Default')
      }`,
      '&:hover': {
        backgroundColor: $isSelected
          ? theme.fn.themeColor('transparent')
          : theme.fn.themeColor('Container/Option_1_(Greige_I)'),
      },
    }))
);
